/*
 * @Author: wufei
 * @Date: 2020-08-07 11:01:31
 * @LastEditTime: 2020-08-24 15:08:52
 * @Description:
 * @FilePath: \mobile-revive\src\utils\common.js
 */
/** 埋点代码
 * _paq index.html中定义的全局变量
 * arg{
 * btnName:'',
 * msg:''
 * }
*/
// eslint-disable-next-line no-unused-vars
export function Gpaq_set(paqInfo = '') {
    Promise.resolve().then(() => {
        // eslint-disable-next-line no-undef
        // _paq.push(['setUserId',paqInfo]);
        // eslint-disable-next-line no-undef
        // _paq.push(['trackPageView']);
    })
}
// eslint-disable-next-line no-unused-vars
export function Gpaq_click({btnName = '', msg = ''} = {}) {
    Promise.resolve().then(() => {
        // eslint-disable-next-line no-undef
        // _paq.push(['trackEvent', 'click',btnName,msg]);
    })
}
// eslint-disable-next-line no-unused-vars
export function Gpaq_warn({msg = ''} = {}) {
    Promise.resolve().then(() => {
        // eslint-disable-next-line no-undef
        // _paq.push(['trackEvent', 'warning', '错误提示',msg]);
    })
}
/** end 埋点代码 */
